module.exports = __webpack_public_path__ + "img/jinganbanner.62e4e115.png";